import { render, staticRenderFns } from "./TasksListView.vue?vue&type=template&id=10d6148f&scoped=true"
import script from "./TasksListView.vue?vue&type=script&lang=js"
export * from "./TasksListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6148f",
  null
  
)

export default component.exports